<template>
  <div class="account__item">
    <div class="account__content">
      <h2 class="title--l">{{ getUiString(['my_account', 'contact_overview', 'title_2']) }}</h2>
      <div class="account__row">
        <div class="account__cell">
          <div class="label">{{ getUiString(['my_account', 'contact_overview', 'email']) }}</div>
          <div class="value">{{ account.EMailAddress }}</div>
        </div>
        <div class="account__cell">
          <div class="label">{{ getUiString(['my_account', 'contact_overview', 'password']) }}</div>
          <div class="value">*********</div>
        </div>
      </div>
      <a class="link link--edit" href="#" @click.prevent="$emit('edit-login')">
        <lennoc-icon image="edit"/>
        <span>{{ getUiString(['my_account', 'contact_overview', 'change_password']) }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'InlogData',
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString',
      account: 'account/shadowAccount'
    })
  }
}
</script>
